import type {
  IdentityProviderIntegration,
  InstalledIdentityProvider,
} from "@p0security/integrations-identity-provider-shared";
import { installedItems } from "@p0security/shared/install/installed";
import { useMemo } from "react";

import { useIntegration } from "./useIntegration";

/** Loads the identity providers an agent identity may be enrolled against.
 *
 * Only installed providers are offered, because registration against any other
 * is rejected by the API.
 */
export const useIdentityProviders = (): {
  error?: string;
  loading: boolean;
  providers: InstalledIdentityProvider[];
} => {
  const { loading, doc, error } =
    useIntegration<IdentityProviderIntegration>("identity-provider");

  const providers = useMemo(() => {
    if (!doc) return [];
    const installed = installedItems("provider", doc.data);
    return Object.entries(installed).flatMap(([id, provider]) =>
      provider ? [{ ...provider, id }] : []
    );
  }, [doc]);

  return {
    error: error
      ? "Identity providers could not be loaded. Try again."
      : undefined,
    loading,
    providers,
  };
};
